module.exports = __webpack_public_path__ + "img/etiquetado7.f70fb8fa.jpg";